import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ItemAddressesProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'item-addresses'
}
